export const hasValue = (value: any) => value !== null && value !== undefined && value !== ''

export const getErrorMessage = (err: unknown, message: string) => {
  if (err instanceof Error) message = err.message
  return message
}
